import React, { useContext, useState, useEffect } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";
import { AppContext } from "../../../../context/AppContext";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";
import Import from "../../../../assets/images/ic-Import.svg";
import ApiConfig from "../../../../api/ApiConfig";
import { getWithAuthCall, simplePostCall } from "../../../../api/ApiServices";
import Loader from "../../../../sharedComponent/Loader";
import NoDataComp from "../../../../sharedComponent/NoDataComp";
import CommonDatePicker from "../../../../sharedComponent/CommonDatePicker";
import { latestDate } from "../../../../sharedComponent/common";
import { Select } from "antd";

const { Option } = Select;

const ListOfTrackingDevices = () => {
  const { sidebar } = useContext(AppContext);
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [vehicleList, setVehicleList] = useState([]);
  const [VehicleId, setVehicleId] = useState("");
  const [OptionDownload, setOptionDownload] = useState("");
  const [OrderListData, setOrderListData] = useState([]);
  const [deviceSummary, setDeviceSummary] = useState([]);
  const [currentDate, setCurrentDate] = useState({ toDayDate: new Date() });
  const [searchVehicleNo, setSearchVehicleNo] = useState("");
  const [searchRegNo, setSearchRegNo] = useState("");
  const [searchVehicleType, setSearchVehicleType] = useState("");
  const maxDate = new Date();

  // Client-side filtering by vehicle number / registration number / vehicle type
  const filteredData = (OrderListData || []).filter((item) => {
    const vn = (item.vehicle_number || "").toString().toLowerCase();
    const rn = (item.vehicle_reg_no || "").toString().toLowerCase();
    const vt = (item.vehicle_type_code || "").toString().toLowerCase();
    return (
      vn.includes(searchVehicleNo.toLowerCase()) &&
      rn.includes(searchRegNo.toLowerCase()) &&
      vt.includes(searchVehicleType.toLowerCase())
    );
  });

  const aninations = {
    initial: { opacity: 0, x: 400 },
    animate: { opacity: 1, x: 0 },
    exit: { opacity: 0, x: 100 },
  };

  useEffect(() => {
    getVehicleList();
  }, []);

  function getVehicleList() {
    getWithAuthCall(ApiConfig.VEHICEL_AVALIVALITY_DROPDAWAN)
      .then((data) => setVehicleList(data?.data || []))
      .catch((err) => console.log("api err", err));
  }

  useEffect(() => {
    fetchReport();
  }, [VehicleId, currentDate, OptionDownload]);

  const fetchReport = () => {
    const body = {
      format: OptionDownload,
      vehicle_id: VehicleId,
      date: latestDate(currentDate.toDayDate, "yyyy-MM-dd"),
    };
    setLoading(true);
    setOptionDownload("");
    simplePostCall(ApiConfig.LIST_OF_TRACKING_DEVICES, JSON.stringify(body))
      .then((res) => {
        if (res?.result) {
          setOrderListData(res?.listData || []);
          setDeviceSummary(res?.deviceList || []);
        } else {
          setOrderListData([]);
          setDeviceSummary([]);
        }
      })
      .catch((err) => console.log("Error:", err))
      .finally(() => setLoading(false));
  };

  return (
    <motion.div
      className={sidebar ? "taskMain " : "cx-active taskMain"}
      id="cx-main"
      variants={aninations}
      initial="initial"
      animate="animate"
      exit="exit"
      transition={{ duration: 0.1 }}
    >
      <div id="cx-wrapper" className="Vehicle_inspition_dashboard heightFixed">
        <div className="report-viwe-head" id="Viwe_Report_Respoasive">
          <p></p>
        </div>

        <div className="col-lg-12 mt-0">
          <div className="UserTabel">
            <div className="heading">
              <div>
                <p>
                  <p>{t("List of Tracking Devices")}</p>
                </p>
              </div>

              <div className="multi-select-1">
                <Select
                  style={{ height: "40px", width: "180px" }}
                  className="custom-select"
                  placeholder={t("Vehicle list")}
                  onChange={(value) => setVehicleId(value)}
                  showSearch
                  filterOption={(input, option) =>
                    option?.label?.toString().toLowerCase().includes(input.toLowerCase())
                  }
                  optionFilterProp="label"
                >
                  <Option value="" style={{ color: "rgba(156, 73, 0)" }}>
                    {t("Vehicle")}
                  </Option>
                  {vehicleList?.map((vehicle) => (
                    <Option
                      key={vehicle.vehicle_id}
                      value={vehicle.vehicle_id}
                      label={vehicle.vehicle_number}
                      style={{ color: "rgba(156, 73, 0)" }}
                    >
                      {vehicle.vehicle_number}
                    </Option>
                  ))}
                </Select>
              </div>

              <div className="innerSelectBox">
                <input
                  type="text"
                  className="form-control"
                  style={{ height: "40px", width: "160px" }}
                  placeholder={t("Vehicle Number")}
                  value={searchVehicleNo}
                  onChange={(e) => setSearchVehicleNo(e.target.value)}
                />
              </div>
              <div className="innerSelectBox">
                <input
                  type="text"
                  className="form-control"
                  style={{ height: "40px", width: "160px" }}
                  placeholder={t("Registration Number")}
                  value={searchRegNo}
                  onChange={(e) => setSearchRegNo(e.target.value)}
                />
              </div>
              <div className="innerSelectBox">
                <input
                  type="text"
                  className="form-control"
                  style={{ height: "40px", width: "150px" }}
                  placeholder={t("Vehicle Type")}
                  value={searchVehicleType}
                  onChange={(e) => setSearchVehicleType(e.target.value)}
                />
              </div>

              <div className="innerSelectBox weekCounter datepicker-main">
                <CommonDatePicker
                  dateKey={"toDayDate"}
                  setDate={setCurrentDate}
                  data={currentDate}
                  SetPlaceholder={t("Today Date")}
                  dataDisbal={maxDate}
                />
              </div>

              <div className="right-export-btn-section-wrapper">
                <div className="md_dropdown">
                  <Dropdown>
                    <Dropdown.Toggle id="dropdown-basic">
                      <img src={Import} alt="" />
                    </Dropdown.Toggle>
                    <Dropdown.Menu>
                      <Dropdown.Item>
                        <Link onClick={() => setOptionDownload("pdf")} className="d-block">
                          {t("PDF")}
                        </Link>
                      </Dropdown.Item>
                      <Dropdown.Item>
                        <Link onClick={() => setOptionDownload("excel")} className="d-block">
                          {t("Excel")}
                        </Link>
                      </Dropdown.Item>
                    </Dropdown.Menu>
                  </Dropdown>
                </div>
              </div>
            </div>

            {deviceSummary && deviceSummary.length > 0 && (
              <div className="row m-2">
                {deviceSummary.map((device, index) => (
                  <div
                    key={index}
                    className="col-md-3 d-flex align-items-center"
                  >
                    <b>{device.hardware_name}</b>
                    <span className="ml-2">: {device.count}</span>
                  </div>
                ))}
              </div>
            )}

            <table className="table tableAdmin">
              <thead className="tableHead">
                <tr className="text-center">
                  <th>{t("Sr No")}</th>
                  <th>{t("Vehicle Number")}</th>
                  <th>{t("Registration No")}</th>
                  <th>{t("IMEI No")}</th>
                  <th>{t("Vehicle Type")}</th>
                  <th>{t("Hardware Name")}</th>
                </tr>
              </thead>
              {loading ? (
                <Loader />
              ) : (
                <tbody className="tableBody">
                  {filteredData && filteredData?.length > 0
                    ? filteredData.map((item, index) => (
                        <tr className="text-center" key={index}>
                          <td>{index + 1}</td>
                          <td>{item.vehicle_number}</td>
                          <td>{item.vehicle_reg_no}</td>
                          <td>{item.vehicle_imei}</td>
                          <td>{item.vehicle_type_code}</td>
                          <td>{item.hardware_name}</td>
                        </tr>
                      ))
                    : null}
                </tbody>
              )}
            </table>

            {filteredData?.length === 0 && !loading && <NoDataComp />}
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ListOfTrackingDevices;
